module.exports = __webpack_public_path__ + "static/media/base-data.76d534cc.png";